"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentViewFeesController = /** @class */ (function () {
    function AdminStudentViewFeesController($stateParams, UsersModel, FlashService) {
        var _this = this;
        this.loading = true;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.fees = [];
        this.student = null;
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            _this.student = response;
        });
        this.UsersModel.getStudentFees(this.$stateParams.userId).then(function (response) {
            _this.fees = response.fees;
            _this.loading = false;
        });
    }
    AdminStudentViewFeesController.prototype.voidFee = function (feeId, index) {
        var _this = this;
        this.submitted = true;
        this.UsersModel.voidFee({
            student_id: this.student.id,
            fee_id: feeId,
        }).then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            response.fee.amount_owed = 0;
            _this.fees[index] = response.fee;
        });
    };
    return AdminStudentViewFeesController;
}());
AdminStudentViewFeesController.$inject = [
    "$stateParams",
    "UsersModel",
    "FlashService",
];
exports.default = AdminStudentViewFeesController;
